import { Checkbox, TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { LocationFormValueToSend, RenderLocationFormProps } from './location-form-props.ts';
import { SyntheticEvent, useEffect, useState } from 'react';
import { Region } from '../../../../../../../core/meta/model/location.ts';
import { GroupHeader, GroupItems } from './location-form-style.tsx';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export const RegionForm = ({
  subcategory,
  options,
  onChange,
  excludeValues,
  locationFormValues,
}: RenderLocationFormProps) => {
  const [values, setValues] = useState<Region[]>([]);
  useEffect(() => {
    setValues(options as Region[]);
  }, [values, options]);

  const regions: Region[] = values.map((region) => {
    const firstLetter = region.name[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...region,
    };
  });

  const handleAutocompleteChange = (
    _event: SyntheticEvent<Element, Event>,
    values: Region[] | null
  ) => {
    const valueToSend: LocationFormValueToSend = {
      name: 'regions',
      values: values?.map((value) => value.key),
    };
    if (valueToSend) onChange(valueToSend);
  };

  const filteredRegions = regions.filter((region) => !excludeValues?.includes(region.key));

  const initialAutoCompleteValues = filteredRegions.filter((region) => {
    return locationFormValues?.regions?.find((data) => data === region.key);
  });

  return (
    <Autocomplete
      id="location-category-region"
      options={filteredRegions.sort(
        (a, b) => -(b?.firstLetter ?? '').localeCompare(a?.firstLetter || '')
      )}
      value={initialAutoCompleteValues}
      limitTags={1}
      multiple
      disableCloseOnSelect
      isOptionEqualToValue={(option, value) => option.key === value.key}
      groupBy={(option) => option?.firstLetter || ''}
      getOptionLabel={(option) => option.name}
      onChange={handleAutocompleteChange}
      renderOption={(props, option, { selected }) => (
        <li {...props} key={option.key}>
          <Checkbox
            name={option.name}
            key={option.key}
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.name}
        </li>
      )}
      renderInput={(params) => <TextField {...params} label={subcategory} />}
      renderGroup={(params) => (
        <li key={params.key}>
          <GroupHeader>{params.group}</GroupHeader>
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
    />
  );
};
